import React from "react";
import { Link } from "react-router-dom"
import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from 'react';
import swal from 'sweetalert';
import APIConfig from "../../api/APIConfig";
import classes from "./styles.module.css";
import ReactLoading from "react-loading"; 
import {
    Box,
    HStack,
    Center,
    Heading,
    Text,
    Button,
    VStack,
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
} from '@chakra-ui/react';


const DetailProposalPage = (props) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [namaProposal, setNamaProposal] = useState("-");
    const [penyelenggara, setPenyelenggara] = useState("-");
    const [tanggalMulai, setTanggalMulai] = useState();
    const [tanggalSelesai, setTanggalSelesai] = useState();
    const [batasWaktuPembayaran, setBatasWaktuPembayaran] = useState();
    const [lokasi, setLokasi] = useState("-");
    const [deskripsi, setDeskripsi] = useState("-");
    const [posisi, setPosisi] = useState("-");
    const [jobdesc, setJobdesc] = useState("");
    const [nominal, setNominal] = useState("");
    const [kriteriaPeserta, setKriteriaPeserta] = useState("-");
    const [kemampuanWajib, setKemampuanWajib] = useState("-");
    const [infoTambahan, setInfoTambahan] = useState("-");
    const [keteranganRevisi, setKeteranganRevisi] = useState("-");
    const [alasanPenolakan, setAlasanPenolakan] = useState("-");
    const [isRevised, setRevisedStatus] = useState(false)
    const [isRejected, setRejected] = useState(false);
    const [idMitra, setIdMitra] = useState("");
    const [kuota, setKuota] = useState();
    const [isSubmitted, setSubmitStatus] = useState(false);
    const [validation, setValidation] = useState({});
    const [spinner, setSpinner] = useState(false);  

    useEffect(() => {
        getProposalById();
        
    }, []);

    const batalkanProposal = async (e) => {
        e.preventDefault();

        swal("Apakah anda yakin ingin membatalkan proposal ini?", {
        buttons: {
            yes: {
            text: "Ya",
            value: "yes"
            },
            no: {
            text: "Kembali",
            value: "no"
            }
        }
        }).then((value) => {
        if (value === "yes") {
            APIConfig.put(`v1/proposal/status/${id}`, {
                statusProposal: "Batal",
            })
            .then(() => {
                swal(
                    {
                        title: "Proposal dibatalkan",
                        icon: "success",
                        button: "OK",
                    }
                ).then(() => {
                    navigate("/mitra/profile/proposal");
                    })
                })
            .catch((error) => {
                console.log(error);
                setValidation(error.response.data);
            })
        }
        return false;
        });
    };


    const getProposalById = async() => {
        setSpinner(true);
        const response = await APIConfig.get(`/v1/proposal/${id}`);
        const data = await response.data
        console.log(data)
        setNamaProposal(data.namaProposal)
        setPosisi(data.namaPosisi)
        setDeskripsi(data.deskripsiAktivitas)
        setJobdesc(data.deskripsiPekerjaan)
        setLokasi(data.lokasi)
        setInfoTambahan(data.infoTambahan)
        setKemampuanWajib(data.kemampuanWajib)
        setKriteriaPeserta(data.kriteriaPeserta)
        setKeteranganRevisi(data.keteranganRevisi)
        setTanggalMulai(data.tanggalMulai)
        setTanggalSelesai(data.tanggalSelesai)
        setBatasWaktuPembayaran(data.batasWaktuPembayaran)
        setPenyelenggara(data.mitra.namaBrand)
        setIdMitra(data.mitra.idMitra)
        setNominal(data.nominal)
        setKuota(data.kuota)
        setKeteranganRevisi(data.keteranganRevisi)
        setAlasanPenolakan(data.alasanPenolakan)
        console.log(data.nominal)

        if(data.statusProposal === 'Butuh Revisi') {
            setRevisedStatus(true);
        }

        if(data.statusProposal === 'Terkumpul') {
            setSubmitStatus(true);
        }

        if(data.statusProposal === 'Ditolak') {
            setRejected(true);
        }

        setSpinner(false);
    };

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
        )
    }

    return (
        <Center py={6}>
        <VStack align='stretch' justifyItems='left' fontFamily={'Inter'} pb={20}>
            <Text
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}>
                Detail Proposal
            </Text>
            <HStack color={'gray.500'} pb={10}>
                <Link to="/mitra/profile/proposal"> Daftar Proposal </Link>
                <p> / </p>
                <Link to={`/mitra/profile/proposal/detail/${id}`}> Detail Proposal </Link>
            </HStack>
            { isRevised &&
                <Box pb={4}>
                <Alert maxWidth={'90%'} borderRadius={'10'} status='warning'>
                    <AlertIcon />
                    <VStack pl={4} pr={4} align='stretch' spacing={3}>
                        <Box>
                            <AlertTitle>Butuh Revisi!</AlertTitle>
                            <AlertDescription>
                            Catatan revisi: {keteranganRevisi} 
                            </AlertDescription>
                        </Box>
                        <Button 
                            onClick={() => navigate(`/mitra/profile/editproposal/${id}`)}
                            fontSize={'small'}
                            color="white"
                            type='submit'
                            width={'50%'}
                            p={4}
                            backgroundColor={'yellow.500'} 
                            rounded={'xl'}
                            variant='solid'>
                            Revisi Proposal
                        </Button>
                    </VStack>
                </Alert>
                </Box>}
            
            { isRejected &&
            <Box pb={4}>
            <Alert maxWidth={'90%'} borderRadius={'10'} status='error'>
                <AlertIcon />
                <VStack pl={4} pr={4} align='stretch' spacing={3}>
                    <Box>
                        <AlertTitle>Maaf, Proposal Anda Ditolak</AlertTitle>
                        <AlertDescription>
                        Alasan Penolakan: {alasanPenolakan} 
                        </AlertDescription>
                    </Box>
                </VStack>
            </Alert>
            </Box>}
            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                rounded={'2xl'}
                p={6}
                overflow={'hidden'}>
                <VStack 
                spacing={6}
                align='stretch'
                p={3}
                >
                    <Heading
                        mb={6}
                        mt={3}
                        fontSize={'xl'}
                        fontFamily={'Inter'}>
                        Detail Aktivitas
                    </Heading>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Nama Aktivitas</h3>
                        <p className={classes.p}>{namaProposal}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Mitra Penyelenggara</h3>
                        <p className={classes.p}>{penyelenggara}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Tanggal Mulai</h3>
                        <p className={classes.p}>{tanggalMulai}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Tanggal Selesai</h3>
                        <p className={classes.p}>{tanggalSelesai}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Batas Waktu Pembayaran</h3>
                        {batasWaktuPembayaran !== null ? 
                            <p className={classes.p}>{batasWaktuPembayaran}</p>
                        :
                            <p className={classes.p}>-</p>
                        } 
                    </VStack>
                    
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Harga</h3>
                        <p className={classes.p}>Rp.{nominal},-</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Lokasi</h3>
                        <p className={classes.p}>{lokasi}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Kuota</h3>
                        <p className={classes.p}>{kuota}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Deskripsi</h3>
                        <p className={classes.p}>{deskripsi}</p>
                    </VStack>

                    <Heading
                        pt={6}
                        fontSize={'xl'}
                        fontFamily={'Inter'}>
                        Detail Lowongan
                    </Heading>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Nama Posisi</h3>
                        <p className={classes.p}>{posisi}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Deskripsi Pekerjaan</h3>
                        <p className={classes.p}>{jobdesc}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Kriteria Peserta</h3>
                        <p className={classes.p}>{kriteriaPeserta}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Kemampuan Wajib</h3>
                        <p className={classes.p}>{kemampuanWajib}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Informasi Tambahan</h3>
                        <p className={classes.p}>{infoTambahan}</p>
                    </VStack>
                    { isRevised &&
                    <VStack align='stretch' spacing={2}>
                    <h3 className={classes.h} >Keterangan Revisi</h3>
                    <p className={classes.p}>{keteranganRevisi}</p>
                    </VStack>}
                </VStack>
                { isSubmitted &&
                <Center pt={6}>
                <HStack spacing={4}>
                    <Button onClick={batalkanProposal} p={6} w='100%' rounded={'xl'} colorScheme='red' fontColor='white' variant="solid">
                        <h3>Batalkan proposal</h3>
                    </Button>
                </HStack>
                </Center>
                }
            </Box>
        </VStack>
        </Center>
    );
}

export default DetailProposalPage;